
import { displayBoards } from '../../../mocks/equipmentHireCatalogue';
import { useScrollAnimation, useStaggeredAnimation } from '../../../hooks/useScrollAnimation';

export default function DisplayBoardsSection() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible, getItemDelay } = useStaggeredAnimation(
    displayBoards.length,
    { staggerDelay: 120 }
  );

  return (
    <section id="display-boards" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div
          ref={titleRef}
          className={`text-center mb-14 transition-all duration-700 ${
            titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-50 border border-amber-200 mb-4">
            <i className="ri-layout-column-line text-amber-600 text-sm"></i>
            <span className="text-amber-700 text-xs tracking-widest uppercase font-semibold">
              Party Rentals
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-stone-900 mb-4">
            <strong>Display Boards</strong>
          </h2>
          <p className="text-stone-500 text-sm max-w-xl mx-auto leading-relaxed">
            Display folder boards and partition dividers to showcase menus, seating charts, and
            signage — or to section off areas with style.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {displayBoards.map((item, index) => (
            <div
              key={item.id}
              style={getItemDelay(index)}
              className={`bg-stone-50 rounded-xl overflow-hidden border border-stone-100 hover:border-amber-200 hover:shadow-xl hover:-translate-y-1 transition-all duration-500 group ${
                gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <div className="relative w-full h-64 overflow-hidden bg-stone-100">
                <img
                  src={item.image}
                  alt={`${item.name} hire Melbourne`}
                  title={`${item.name} party rental Melbourne`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>

              <div className="p-6">
                <h3 className="font-display text-xl text-stone-900 mb-2">{item.name}</h3>
                <p className="text-stone-500 text-sm leading-relaxed mb-5">{item.description}</p>

                <div className="flex items-center justify-between pt-4 border-t border-stone-100">
                  <div>
                    <span className="text-2xl font-bold text-amber-600">${item.price}</span>
                    <span className="text-stone-400 text-xs ml-1">{item.unit}</span>
                  </div>
                  <a
                    href="#hire-inquiry"
                    className="px-5 py-2.5 bg-stone-900 text-white text-xs font-semibold rounded-full hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-mail-send-line mr-1.5"></i>Enquire
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
